module.exports = __webpack_public_path__ + "static/media/template5.0be99224.png";